import React from "react";
import { NavLink } from "react-router-dom";
import axios from "../../../../../axios";
import { Box, Button, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import { toast } from "react-toastify";

const ScheduledThreeDotPopup = ({
  setDelete,
  setDeactiveProcess,
  assessmentId,
  isAdaptive,
  autoEvaluate,
}) => {
  const handleDeactivate = async () => {
    try {
      const res = await axios.put(
        `/api/v1/assessment/updateStatus/${assessmentId}`,
        { status: "draft" }
      );
      if (res) {
        toast.success("Assessment Deactivated Successfully");
        setDeactiveProcess((prev) => !prev);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
        minWidth: 160,
      }}
    >
      <Stack spacing={2}>
        <NavLink
          to="/EditScheduledQList"
          state={{ assessmentId, isAdaptive, autoEvaluate }}
          style={{ textDecoration: "none" }}
        >
          <Button
            variant="outlined"
            color="warning"
            startIcon={<EditIcon />}
            fullWidth
            sx={{ textTransform: "none", whiteSpace: "nowrap" }}
          >
            Edit
          </Button>
        </NavLink>

        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          fullWidth
          onClick={() => setDelete(true)}
          sx={{ textTransform: "none", whiteSpace: "nowrap" }}
        >
          Delete
        </Button>

        <Button
          variant="outlined"
          color="warning"
          startIcon={<BlockIcon />}
          fullWidth
          onClick={handleDeactivate}
          sx={{ textTransform: "none", whiteSpace: "nowrap" }}
        >
          Deactivate
        </Button>
      </Stack>
    </Box>
  );
};

export default ScheduledThreeDotPopup;
